const IDP_ICON_MICROSOFT = '/img/auth/idp-microsoft.svg';
const IDP_ICON_GITHUB = '/img/auth/idp-github.svg';
const IDP_ICON_OKTA = '/img/auth/idp-okta.svg';
const IDP_ICON_ONELOGIN = '/img/auth/idp-onelogin.svg';
const IDP_ICON_GOOGLE = '/img/auth/idp-google.svg';
const IDP_ICON_WORKOS = '/img/auth/idp-workos.svg';

const IDP_ICON_RULES = [
  { icon: IDP_ICON_MICROSOFT, pattern: /microsoft|entra|azure|aad|msal|microsoftonline|windows\.net/ },
  { icon: IDP_ICON_GITHUB, pattern: /github/ },
  { icon: IDP_ICON_OKTA, pattern: /okta/ },
  { icon: IDP_ICON_ONELOGIN, pattern: /onelogin/ },
  { icon: IDP_ICON_GOOGLE, pattern: /google/ },
  { icon: IDP_ICON_WORKOS, pattern: /workos/ },
];

const IDP_HAYSTACK_KEYS = [
  'displayName',
  'name',
  'provider',
  'protocol',
  'issuer',
  'connectionId',
  'identityProvider',
  'idp',
];

function idpHaystack(idp) {
  if (!idp || typeof idp !== 'object') return '';
  return IDP_HAYSTACK_KEYS.map((key) => idp[key])
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function idpIconSrc(idp) {
  const haystack = idpHaystack(idp);
  if (!haystack) return '';
  const match = IDP_ICON_RULES.find((rule) => rule.pattern.test(haystack));
  return match ? match.icon : '';
}
